/**
 * Created by stonewang on 2017/9/10.
 */
import {config, request} from 'Utils';

//新闻列表
export function list(param) {
  return request(`${config.server}/api/v1/dms/news/getNewsList`, {
    method: 'post',
    body: param,
  });
}
//新增资讯新闻
export function add(param) {
  /*
   {
   content (string, optional): 正文 ,
   id (integer, optional): 资讯ID ,
   imgUrl (string, optional): 图片url ,
   isCanForward (integer, optional): 是否可以转发（0，否，1是） ,
   isComment (integer, optional): 是否可评论(0,否，1是) ,
   isPublish (integer, optional): 是否发布（0，否，1是） ,
   isShow (integer, optional): 是否首页显示（0,否，1是） ,
   keyword (string, optional): 关键字 ,
   organizationName (string, optional),
   rangeList (Array[integer], optional): 发布范围ID列表 ,
   title (string, optional): 标题 ,
   type (string, optional): 类型（0新闻资讯） ,
   }
  * */
  return request(`${config.server}/api/v1/dms/news/insertNews`, {
    method: 'post',
    body: param,
  });
}
//修改资讯新闻
export function modify(param) {
  return request(`${config.server}/api/v1/dms/news/modify`, {
    method: 'post',
    body: param,
  });
}
//资讯新闻详情
export function detail(param) {
  return request(`${config.server}/api/v1/dms/news/newsDetail?id=${param}`);
}
//发布和撤回接口
export function publishOrDownNews(param) {
  return request(`${config.server}/api/v1/dms/news/publishOrDownNews`, {
    method: 'post',
    body: param,
  });
}
//首页展示
export function showFirstPage(param) {
  return request(`${config.server}/api/v1/dms/news/showFirstPage`, {
    method: 'post',
    body: param,
  });
}
//获取资讯发布的范围接口
export function infoPublishList() {
  return request(`${config.server}/api/v1/dms/treeRelation/infoPublishList`);
}


// WEBPACK FOOTER //
// ./src/service/info/index.js